import { __assign, __read, __rest } from "tslib";
import React, { useState, useEffect } from 'react';
import { Dropdown } from '@tencent/tea-component/lib/dropdown';
import { BuyRegionOption, BuyRegionOptionContext } from './BuyRegionOption';
import { getPropsFromChildrenByType } from '@tencent/tea-component/lib/_util/get-props-from-children-by-type';
import { Tabs, TabPanel } from '@tencent/tea-component/lib/tabs';
export function BuyRegionGroup(_a) {
    var children = _a.children, name = _a.name, type = _a.type;
    if (type === 'tabs') {
        return (React.createElement("div", { className: "tabs-container" },
            React.createElement("div", { className: "tea-segment" }, children)));
    }
    return (React.createElement("div", { className: "buy-areas-region-item" },
        React.createElement("div", { className: "buy-areas-region-info" }, name),
        React.createElement("div", { className: "tea-segment" }, children)));
}
export function BuyRegionPanel(_a) {
    var children = _a.children, type = _a.type, activeId = _a.activeId, defaultActiveId = _a.defaultActiveId, disabledIds = _a.disabledIds, onChange = _a.onChange;
    if (typeof activeId === 'undefined' && typeof defaultActiveId === 'undefined') {
        // 若没有 则默认显示第一个
        // eslint-disable-next-line no-param-reassign
        defaultActiveId = '0';
    }
    var _b = __read(useState(defaultActiveId), 2), internalActiveId = _b[0], setInternalActiveId = _b[1];
    var _c = __read(useState([]), 2), regionList = _c[0], setRegionList = _c[1];
    useEffect(function () {
        setInternalActiveId(activeId);
    }, [activeId]);
    useEffect(function () {
        // 将可用区按当前tab进行封装
        var list = [];
        React.Children.map(children, function (child, index) {
            var _a, _b, _c, _d, _e, _f;
            list.push({
                type: (_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.type,
                name: (_b = child === null || child === void 0 ? void 0 : child.props) === null || _b === void 0 ? void 0 : _b.name,
                id: (_d = (_c = child === null || child === void 0 ? void 0 : child.props) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : index.toString(),
                children: (_f = (_e = child === null || child === void 0 ? void 0 : child.props) === null || _e === void 0 ? void 0 : _e.children) === null || _f === void 0 ? void 0 : _f.map(function (i) { return i === null || i === void 0 ? void 0 : i.props; }),
            });
        });
        setRegionList(list);
    }, []);
    var onActive = function (tab) {
        setInternalActiveId(tab.id);
        if (onChange) {
            var groupRegion = (regionList === null || regionList === void 0 ? void 0 : regionList.filter(function (i) { return (i === null || i === void 0 ? void 0 : i.id) === (tab === null || tab === void 0 ? void 0 : tab.id); })) || [];
            // 切换地域tab时，添加触发事件，并传递当前tab下的可用区信息
            onChange(tab.id, groupRegion[0]);
        }
    };
    if (type === 'tabs') {
        return (React.createElement(Tabs, { tabs: React.Children.map(children, function (child, index) {
                var _a, _b, _c, _d, _e, _f, _g;
                return ({
                    id: (_b = (_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : index.toString(),
                    label: (_c = child === null || child === void 0 ? void 0 : child.props) === null || _c === void 0 ? void 0 : _c.name,
                    hasNewArea: ((_d = child === null || child === void 0 ? void 0 : child.props) === null || _d === void 0 ? void 0 : _d.hasNewArea) || false,
                    disabled: ((_e = child === null || child === void 0 ? void 0 : child.props) === null || _e === void 0 ? void 0 : _e.disabled) || (disabledIds === null || disabledIds === void 0 ? void 0 : disabledIds.includes((_g = (_f = child === null || child === void 0 ? void 0 : child.props) === null || _f === void 0 ? void 0 : _f.id) !== null && _g !== void 0 ? _g : index.toString())) || false,
                });
            }), onActive: onActive, tabBarRender: function (children, tab) { return (React.createElement("div", null, tab.hasNewArea ? (React.createElement("span", { className: "" + (tab.hasNewArea ? 'new-info' : '') }, children)) : (children))); }, defaultActiveId: defaultActiveId, activeId: internalActiveId }, React.Children.map(children, function (child, index) {
            var _a, _b, _c, _d;
            return React.createElement(TabPanel, {
                id: (_b = (_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : index.toString(),
                key: (_d = (_c = child === null || child === void 0 ? void 0 : child.props) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : index.toString(),
            }, child);
        })));
    }
    return (React.createElement("div", { id: "bug-region-select", className: "buy-areas-region" }, children));
}
BuyRegionPanel.Group = BuyRegionGroup;
export function BuyRegionSelect(props) {
    var options = getPropsFromChildrenByType(props.children, BuyRegionOption);
    var value = props.value, children = props.children, onChange = props.onChange, dropdownProps = __rest(props, ["value", "children", "onChange"]);
    var _a = __read(useState(value || options[0].value), 2), curRegion = _a[0], setCurRegion = _a[1];
    useEffect(function () {
        setCurRegion(value || options[0].value);
    }, [value, options]);
    var handleOptionClick = function (val, event) {
        onChange(val, event);
        setCurRegion(val);
    };
    var selectedOption = options.find(function (x) { return x && x.value === curRegion; }) || options[0];
    if (props.type === 'tabs') {
        return (React.createElement("div", { className: "buy-component-tabs", style: dropdownProps.style },
            React.createElement(BuyRegionOptionContext.Provider, { value: {
                    inject: function (props) {
                        return __assign(__assign({}, props), { selected: curRegion === props.value, onClick: function (e) {
                                if (typeof props.onClick === 'function') {
                                    props.onClick(e);
                                }
                                if (e.isDefaultPrevented()) {
                                    return;
                                }
                                handleOptionClick(props.value, e);
                            } });
                    },
                } }, children)));
    }
    return (React.createElement("div", { className: "buy-areas" },
        React.createElement(Dropdown, __assign({}, dropdownProps, { trigger: "click", clickClose: true, style: { marginRight: 10 }, appearance: "button", button: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.children, boxClassName: "buy-areas-region-dropdown" }),
            React.createElement(BuyRegionOptionContext.Provider, { value: {
                    inject: function (props) {
                        return __assign(__assign({}, props), { selected: curRegion === props.value, onClick: function (e) {
                                if (typeof props.onClick === 'function') {
                                    props.onClick(e);
                                }
                                if (e.isDefaultPrevented()) {
                                    return;
                                }
                                handleOptionClick(props.value, e);
                            } });
                    },
                } }, children))));
}
//# sourceMappingURL=BuyRegionSelect.js.map